import React, { Fragment, useState } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import blank_img from '../../images/blank_img.png'
import aImg2 from '../../images/about/about_image_4.webp'
import ModalVideo from 'react-modal-video'
import PolicySection from './Policy';
import WhyUs from './WhyUs';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import FaqsSection from '../../components/FaqSection/FaqSection';
import TrialFrom from '../../components/TrialForm/trialfrom';
import Journey from '../../components/journey/journey';
import { Link } from 'react-router-dom';


const AboutUsPage = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>We are the go-to choice for <br/> small property owners.</h1>
                                    <br/>
                                    <p className='mb-0'>That’s why every hour another property owner chooses to partner with us.</p>
                                </div>
                            </div>
                        </div>
                </section>
                {/* <PolicySection /> */}
                <FeaturesSection />
                <section className="intro_about_section section_space pb-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={blank_img}/>
                                </div>
                                <div className="col-lg-6">
                                    <h2><span>Who</span> we are.</h2>
                                    <p>We’re a multi-award winning all-in-one hotel management solution. At Little Hotelier, we believe that size shouldn’t limit quality. You’ll find cutting-edge SiteMinder technology here—trusted by the biggest names in hospitality—adapted for all types of small properties. </p>
                                    <p>Whether you have five rooms or fifty, our goal is to empower you with the technology you need to achieve more.</p>
                                </div>

                            </div>
                        </div>
                </section>

                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2><span>What</span> we do.</h2>
                                    <p>For over a decade, we’ve championed software for small properties that reduces manual admin, centralises business activities and helps you grow. Along with the world’s most powerful sales distribution capabilities to fill more of your rooms, our all-in-one software empowers you to manage guests, payments, communication, pricing, and data effortlessly—all from a single platform, giving you greater control over your business.</p>
                                    <p><b>With Little Hotelier, you will</b></p>

                                    <p className='mb-0'>Boost your bookings</p>
                                    <p className='mb-0'>Make business simple</p>
                                    <p className='mb-0'>Get help when you need it</p>
                                </div>

                                <div className="col-lg-6">
                                    <img src={blank_img}/>
                                </div>

                            </div>
                        </div>
                </section>

                <section className="what_drive section_space">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-12 what_drive_inside">
                            <h2>What drives us.</h2>
                            <p>Our vision is simple. We work every day to solve challenges for small <br/> hoteliers through the use of dedicated, simple and automated technology.</p>
                        </div>
                        </div>
                    </div>
                </section>
                <FaqsSection/>
                <section className="work_thats section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-3">
                                    <h2>Work that’s <br/>
                                    worthwhile.</h2>
                                </div>
                                <div className="col-lg-9">
                                    <p>Looking to make an impact in the lives of tens of thousands of hoteliers worldwide? Join a team of passionate, compassionate, and brilliant individuals for your most rewarding career move yet.
                                    </p>

                                    <Link to="/" className='learn_more'>Learn More</Link>
                                </div>
                            </div>
                        </div>
                </section>
                <TrialFrom />
                <Journey />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutUsPage;
